/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/* eslint-disable @atlaskit/design-system/use-tokens-typography */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { MetadataBlock } from './MetadataBlock';

export default MetadataBlock;

/**
 * @deprecated Use `import { MetadataBlock } from '@atlaskit/smart-card/metadata-block'` instead.
 */
export { MetadataBlock } from './MetadataBlock';
